import { useMutation } from '@biletiniz/apollo';
import { RESET_PASSWORD } from './gql/reset-password';

export const useResetPassword = () => {
  const [resetPasswordMutation, { loading, error }] = useMutation(
    RESET_PASSWORD
  );

  const resetPassword = resetPasswordInfo => {
    return resetPasswordMutation({
      variables: resetPasswordInfo,
    });
  };

  const initialValues = {
    password: '',
    confirm: '',
  };

  return {
    error: error?.message,
    resetPassword,
    loading,
    initialValues,
  };
};